exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width: 768px) {\r\n  .modal {\r\n    padding: 0 !important;\r\n  }\r\n  .modal-dialog {\r\n    margin: 20px auto;\r\n  }\r\n  .top-content-menu.column-middle,\r\n  .top-content-menu.column-right {\r\n    display: none;\r\n  }\r\n  .top-content-menu .top-content-menu-bg {\r\n    border: none;\r\n    border-radius: 0;\r\n    position: fixed;\r\n    z-index: 1;\r\n  }\r\n  .ticket-wrapper {\r\n    border: none;\r\n    border-radius: 0;\r\n    height: auto;\r\n    position: absolute;\r\n    top: 68px;\r\n    width: 100%;\r\n    z-index: 0;\r\n  }\r\n  .modal-dialog {\r\n    margin: 20px auto;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 568px) {\r\n  .modal-dialog {\r\n    margin: 0;\r\n    border-radius: 0;\r\n    height: 100%;\r\n    background-color: #fff;\r\n  }\r\n  .modal-title,\r\n  .new-ticket-body .ticket-action-button.bg-action-button {\r\n    border-radius: 0;\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Work-Local/frontend/src/app/ticket/_css-ticket/ticket-content-mobile-responsive-filter.css
// module id = ../../../../../src/app/ticket/_css-ticket/ticket-content-mobile-responsive-filter.css
// module chunks = main